import {
  ProductSourceAutocompleteDocument,
  type ProductSourceAutocompleteQuery,
  type ProductSourceAutocompleteQueryVariables,
} from "@/generated/graphql";
import type { AutocompleteFetchResult } from "@k3-tech/react-kit";
import { useCallback } from "react";
import { useClient } from "urql";

export const useProductSourceAutocomplete = () => {
  const urqlClient = useClient();

  const load = useCallback(
    async (page: number, pageSize: number, search: string) => {
      const { data } = await urqlClient
        .query<
          ProductSourceAutocompleteQuery,
          ProductSourceAutocompleteQueryVariables
        >(
          ProductSourceAutocompleteDocument,
          {
            qop: {
              pagination: {
                page,
                pageSize,
                withCount: true,
              },
              filters: { productSourceName: search },
            },
          },
          { suspense: false, requestPolicy: "network-only" },
        )
        .toPromise();

      const rawItems = (data?.productSources?.items ?? []) as NonNullable<
        ProductSourceAutocompleteQuery["productSources"]
      >["items"];
      const items = (rawItems || [])
        .filter((it): it is NonNullable<typeof it> => Boolean(it))
        .map((item) => ({ value: item.productSourceID, label: item.productSourceName, raw: item }));

      return {
        items: items ?? [],
        total: data?.productSources?.pagination?.totalRows ?? 0,
        hasMore: data?.productSources?.pagination?.hasNext ?? false,
      } as AutocompleteFetchResult;
    },
    [urqlClient],
  );

  return { load };
};
